import { render, staticRenderFns } from "./ui-cropper.vue?vue&type=template&id=dbd3f2ea&scoped=true"
import script from "./ui-cropper.vue?vue&type=script&lang=js"
export * from "./ui-cropper.vue?vue&type=script&lang=js"
import style0 from "./ui-cropper.vue?vue&type=style&index=0&id=dbd3f2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd3f2ea",
  null
  
)

export default component.exports